module.exports = __webpack_public_path__ + "static/media/insights.5fa45f02.svg";